// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"0511f1ff","71":"0a3419c9","433":"26811ec7","506":"9f8b33d8","744":"4a6145e8"}[chunkId] + ".chunk.js";
};